/*
export function someAction (context) {
}
*/

import * as Sentry from '@sentry/browser'
import { $axios } from 'src/boot/axios'
import { Notify } from 'quasar'

export function loadUser (context) {
  console.log('Loading User')
  return $axios.get('/api/v0/fe/profile')
    .then(response => response.data)
    .then(user => {
      context.commit('setUser', user)
      return user
    }).then(user => {
      Sentry.setUser({ id: user.id, email: user.email })
    })
}

export function loadClient (context, clientId) {
  return $axios.get('/api/v0/clientAccounts/' + clientId)
    .then(response => response.data)
    .then(client => {
      console.log('Loading ClientAcc', client)
      context.commit('setEffectiveClientAcc', client)
    })
}

export function logout (context) {
  return Promise.all([
    context.commit('user/clearAll', null, { root: true }),
    context.commit('app/clearAll', null, { root: true })
  ])
}

export function requestSwitchClient (context, clientAccId) {
  console.log('Changing client account to ' + clientAccId)
  return $axios.post('/api/authenticate/adoptClientAccount', {
    effectiveClientAccId: clientAccId
  })
    .then(function (response, err) {
      // changing client ID
      // ditch all App/Entity/State
      return Promise.all([
        // context.commit('user/clearAll', null, { root: true }),
        context.commit('app/clearAll', null, { root: true }),
        context.commit('setToken', response.data.id_token)
      ])
    }).then(() => {
      return context.dispatch('loadClient', clientAccId)
    }).then(() => {
      return context.dispatch('app/loadAllMyApps', null, { root: true })
    })
    .catch(function (error) {
      Notify.error(error.message)
      throw error
    })
}

export function setUserProperty (context, payload) {
  context.commit('setUserProperty', payload)
}
